<template>
  <footer :class="['powered-by-footer', { 'has-bottom-nav': bottomNav }]">
    <span>Powered by</span>
    <img :src="logo" alt="Mazzitech" />
  </footer>
</template>

<script>
import logo from "@/assets/images/logo-mazzitech.png";

export default {
  name: "PoweredByFooter",
  props: {
    bottomNav: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      logo,
    };
  },
};
</script>

<style lang="scss" scoped>
.powered-by-footer {
  width: 100%;
  padding: 22px 16px 26px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  color: #8a928c;
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0;
  text-align: center;

  img {
    width: 92px;
    max-width: 34vw;
    height: auto;
    display: block;
    opacity: 0.72;
  }
}

@media (max-width: 959px) {
  .powered-by-footer.has-bottom-nav {
    padding: 10px 16px calc(18px + 72px + env(safe-area-inset-bottom));
  }
}
</style>
